import './Products.css';
import React, { useState, useEffect, useRef } from "react";
import Navbar from '../Navbar/Navbar';
import Banner from '../assets/Industries/silandeIndustries.png';
import Footer from '../Footer/Footer';
import { useLocation } from "react-router-dom";
import WhatsappVerde from '../assets/Home/whatsappVerde.png'

// Secciones
import Construccion from './Construccion/Construccion';
import Led from './Led/Led';
import Automotriz from './Automotriz/Automotriz';
import PanelesSolares from './PanelesSolares/PanelesSolares';
import Impermeabilizantes from './Impermeabilizantes/Impermeabilizantes';

function Products() {
    const location = useLocation();
    const topRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const tabMap = {
        "Construcción": 1,
        "Electrónico": 2,
        "Automotriz": 3,
        "Paneles solares": 4,
        "Impermeabilizantes": 5
    };

    const selectedFromState = location.state?.tab;
    const initialTab = tabMap[selectedFromState] || (window.innerWidth < 768 ? null : 1);

    const [selectedTab, setSelectedTab] = useState(initialTab);

    // Scroll al top al seleccionar tab
    const handleTabClick = (id) => {
        setSelectedTab(id);
        if (topRef.current) {
            topRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    // Manejar resize y comportamiento responsive
    useEffect(() => {
        const handleResize = () => {
            const isNowMobile = window.innerWidth < 768;
            setIsMobile(isNowMobile);
            if (!isNowMobile && selectedTab === null) {
                setSelectedTab(1);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [selectedTab]);

    // Solo al montar: si es mobile, arranca sin tab seleccionada
    useEffect(() => {
        if (window.innerWidth < 768) {
            setSelectedTab(null);
        }
    }, []);

    const tabs = [
        { id: 1, label: 'Construcción', component: <Construccion /> },
        { id: 2, label: 'Electrónica', component: <Led /> },
        { id: 3, label: 'Automotriz', component: <Automotriz /> },
        { id: 4, label: 'Paneles solares', component: <PanelesSolares /> },
        { id: 5, label: 'Impermeabilizantes', component: <Impermeabilizantes /> }
    ];

    return (
        <>
            <Navbar />
            <div ref={topRef}></div>
            <div className="banner-container-industries">
                <img src={Banner} alt="Banner" className="banner-image-industries" />
            </div>

            {!isMobile ? (
                <ul className="tabs-container-industries">
                    {tabs.map(tab => (
                        <li
                            key={tab.id}
                            className={selectedTab === tab.id ? "tab-industries active" : "tab-industries"}
                            onClick={() => handleTabClick(tab.id)}
                        >
                            {tab.label}
                        </li>
                    ))}
                </ul>
            ) : (
                <div className="accordion-container-industries">
                    {tabs.map(tab => (
                        <div key={tab.id} className="accordion-item-industries">
                            <div
                                className="accordion-header-industries"
                                onClick={() =>
                                    handleTabClick(selectedTab === tab.id ? null : tab.id)
                                }
                            >
                                <span>{tab.label}</span>
                                <span className="accordion-icon-industries">
                                    {selectedTab === tab.id ? '▼' : '▶'}
                                </span>
                            </div>
                            {selectedTab === tab.id && (
                                <div className="accordion-content-industries">
                                    {tab.component}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {!isMobile && selectedTab !== null && (
                <div className="content-container-industries">
                    {tabs.find(tab => tab.id === selectedTab)?.component}
                </div>
            )}

            <Footer />
            <button
                className="whatsapp-button"
                onClick={() => window.open("https://wa.me/+5491151489606", "_blank")}
            >
                <img src={WhatsappVerde} alt="WhatsApp" />
            </button>
        </>
    );
}

export default Products;
